import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import { fontFamily, fontSize, fontWeight } from '../theme'
import { margin } from '../styledHelpers'

const HeadingMedium = styled.h2 `
  font-family: ${fontFamily};
  color: ${props => props.theme.colors[props.color]};
  font-size: ${fontSize.hMedium};
  font-weight: ${fontWeight.light};
  margin: 0;
  letter-spacing: 0.02rem;
  line-height: 1.3;
  ${props => props.center && `text-align: center;`};
  ${props => props.block && "display: block;"}
  ${props => props.hyphenate && "hyphens: auto;"}
  ${margin}
  
  ${props => props.responsive && 
  `@media(min-width: 641px) {
    font-size: ${fontSize.hMediumDesktop(props)}
  }`}
`

HeadingMedium.defaultProps = {color: 'primary'}

const HeadingLarge = HeadingMedium.withComponent('h1').extend`
  font-size: ${fontSize.hLarge};
  letter-spacing: 0.03rem;
 
  ${props => props.responsive && 
  `@media(min-width: 641px) {
    font-size: ${fontSize.hLargeDesktop(props)}
  }`}
`
const HeadingSmall = HeadingMedium.withComponent('h3').extend`
  font-size: ${fontSize.hSmall};
  
  ${props => props.responsive && 
  `@media(min-width: 641px) {
    font-size: ${fontSize.hSmallDesktop(props)}
  }`}
`

const HeadingExtraSmall = HeadingMedium.withComponent('h4').extend`
  font-size: ${fontSize.hExtraSmall};
`

const Heading = (props) => {
  let Component = HeadingMedium
  if (props.size === 'large')
    Component = HeadingLarge
  else if (props.size === 'small')
    Component = HeadingSmall
  else if (props.size === 'xs')
    Component = HeadingExtraSmall
  return <Component {...props} />
}

Heading.propTypes = {
  size: PropTypes.string
}

export {Heading as default, HeadingExtraSmall, HeadingSmall, HeadingMedium, HeadingLarge}


// WEBPACK FOOTER //
// ./assets/common/components/Heading.js